import {getGlobalConstant} from '@/resource/js/public_link';
import {invokeApi} from './GLOBAL2'

let globalConst = getGlobalConstant();
var _hmt = _hmt || [];
_hmt.push(['_setCustomVar', 1, 'customer', '测试', 1]);


(function() {
    invokeApi('customer/getCustomerIds',{},'post',Math.random(),function (res) {
        console.log(res);
        _hmt.push(['_setCustomVar', 1, 'customer', res.customerId, 1]);
    })
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?"+globalConst.baiduAnalysis;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);

})();



// WEBPACK FOOTER //
// ./src/resource/js/baiduAnalysis.js